export default __webpack_public_path__ + "static/a4fea7beebf717ea7611865c030d944c.png";